<template>
  <div class="flex flex-col">
    <p
      class="text-2xs"
      :class="typeClass"
    >
      Insider - {{ insider.type }}
    </p>
    <p class="text-xs font-semibold text-primary dark:text-primary-dark">
      {{ insider.person }}
    </p>

    <p
      class="font-medium text-xs"
      :class="[typeClass]"
    >
      <span>{{ parseFloat(insider.volume).toLocaleString('en-US', {maximumFractionDigits: 2}).replace(/,/g, ' ') }}</span>
      á <span>{{ insider.price }} {{ insider.currency }}</span>
    </p>
    <p class="text-2xs">
      {{ publishDate }}
    </p>
  </div>
</template>

<script>

export default {
  name: 'InsiderTradeMini',
  props: {
    insider: {
      type: Object,
      default: () => {}
    },
    icon: {
      type: String,
      default: 'coin-stack'
    },
    typeClass: {
      type: String,
      default: 'text-grey-700'
    },
    positive: {
      type: Boolean,
      default: false
    },
    companyName: {
      type: String,
      default: ''
    },
    companyId: {
      type: Number,
      default: 0
    },
    publishDate: {
      type: String,
      default: ''
    }
  }
}
</script>
